import React from 'react';
import PropTypes from 'prop-types';
import './styles.module.scss';

import TableRowGroup, { TableElement } from '../TableRowGroup/TableRowGroup';

/**
 * Table for PDP Size Chart
 */
const Table = ({
  headerRowGroups,
  tableBodyRowGroups,
  hasDarkenedFirstColumn,
  computeTableBodyRowStyle = () => 'trDefault',
  cellWidth,
}: {
  hasDarkenedFirstColumn?: boolean;
  headerRowGroups?: TableElement[][][];
  tableBodyRowGroups: TableElement[][][];
  computeTableBodyRowStyle?: (rowGroupIndex: number) => string;
  cellWidth: string;
}) => {
  return (
    <table styleName="table">
      {!!headerRowGroups?.length && (
        <thead>
          {headerRowGroups.map((groupOfRows, index) => {
            return (
              // eslint-disable-next-line react/no-array-index-key
              <TableRowGroup key={index} rows={groupOfRows} isRowInHeader />
            );
          })}
        </thead>
      )}
      <tbody>
        {tableBodyRowGroups.map((groupOfRows, rowGroupIndex) => {
          return (
            <TableRowGroup
              /* eslint-disable-next-line react/no-array-index-key */
              key={rowGroupIndex}
              hasDarkenedFirstColumn={hasDarkenedFirstColumn}
              rows={groupOfRows}
              rowStyle={computeTableBodyRowStyle(rowGroupIndex)}
              firstColumnColspan={
                headerRowGroups?.length ? headerRowGroups[0][0][0].colspan : 1
              }
              cellWidth={cellWidth}
            />
          );
        })}
      </tbody>
    </table>
  );
};

Table.defaultProps = {
  hasDarkenedFirstColumn: false,
  headerRowGroups: [],
  computeTableBodyRowStyle: () => 'trDefault',
  cellWidth: 'small',
};

Table.propTypes = {
  hasDarkenedFirstColumn: PropTypes.bool,
  headerRowGroups: PropTypes.arrayOf(
    PropTypes.arrayOf(
      PropTypes.arrayOf(
        PropTypes.shape({
          value: PropTypes.string.isRequired,
          colspan: PropTypes.number,
          rowspan: PropTypes.number,
        }),
      ),
    ),
  ),
  tableBodyRowGroups: PropTypes.arrayOf(
    PropTypes.arrayOf(
      PropTypes.arrayOf(
        PropTypes.shape({
          value: PropTypes.string.isRequired,
          colspan: PropTypes.number,
          rowspan: PropTypes.number,
        }),
      ),
    ),
  ).isRequired,
  computeTableBodyRowStyle: PropTypes.func,
  cellWidth: PropTypes.string,
};

export default Table;
